// extracted by mini-css-extract-plugin
export default {"a":"privacy_a__8THn5","section":"privacy_section__00+Ij","main":"privacy_main__ePsQT","geen_opmaak":"privacy_geen_opmaak__tvR9q","fanfareLink":"privacy_fanfareLink__SpzhU"};